import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';
import styled from 'styled-components';
import CellHover from '../components/CellHover';
import CourtDeptDetailHover from './CourtDeptDetailHover';

const DeptRow = styled.tr`
  &:nth-child(odd) {
    background: #d6a979;
  }
  &:nth-child(even) {
    background: #ffdda9;
  }
  &:hover {
    background: #ddd;
  }
`;
DeptRow.displayName = 'DeptRow';

const MonoField = styled.td`
  font-family: consolas, courier, mono;
  padding: 0 10px 0 5px;
`;
MonoField.displayName = 'MonoField';

const VarField = styled.td`
  font-family: georgia, "Times New Roman", serif;
  padding: 0 5px;
`;
VarField.displayName = 'VarField';

const courtDeptListRow = props => {

  const navigate = useNavigate();

  function handleDoubleClick() {
    navigate(`/CourtDepartment/detail/${props.judicial_district}/${props.department}/${props.court_type}`);
  }

  function datetimeToDate(isoDT) {
    const dt = DateTime.fromISO(isoDT);
    return dt.isValid ? dt.toISODate() : '';
  }

  return (
    <DeptRow onDoubleClick={handleDoubleClick}>
      <MonoField style={{textAlign: 'center'}}>{props.court_type}</MonoField>
      <MonoField>{props.judicial_district}</MonoField>
      <MonoField>{props.department}</MonoField>
      <CellHover style={{fontFamily: 'georgia, serif', padding: '0 5px'}}>
        {props.description}
        <CourtDeptDetailHover {...props} />
      </CellHover>
      <VarField>{props.address}</VarField>
      <MonoField>{props.phone}</MonoField>
      <MonoField>{datetimeToDate(props.exp_date)}</MonoField>
    </DeptRow>
  )
}

export default courtDeptListRow;